<template>
  <v-container class="px-6">
    <h1>Processos de identificação de Pagamentos</h1>
    <p>Acompanhe o monitoramento diário por operadora, prestador e login.</p>
    <IdentificacaoFilter
      :prestadores="prestadores"
      :operadoras="listOperadora"
      :filterList="(formData) => getList(formData, 1)"
      :getOperadoras="(opts)=>getOperadoras(opts)"
      :hoje="hoje"
    />
    <List
      :list="list"
      :filterData="filter"
      :pagination="pagination"
      :getHistorico="(item)=>getHistorico(item)"
      :getList="(filterData, page)=>getList(filterData, page)"
      :showOpen="(item) => showOpen(item)"
    />
    <HistoricoEventosDlg
      :dialog="dialog"
      :close="() => dialog = false"
      :historico="historico"
      :type="true"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import IdentificacaoFilter from './monitor_de_pagamento/Filter'
import List from './monitor_de_pagamento/List'
import HistoricoEventosDlg from './monitor_de_pagamento/HistoricoEventosDlg'
export default {
  components: {
    IdentificacaoFilter,
    List,
    HistoricoEventosDlg
  },
  data() {
    return{
      dialog: false,
      filter: null,
      historico: {},
      hoje: null,
      list: [],
      prestadores: [],
      pagination: {
        limit: 20,
        offset: 1,
        total: null,
        total_pages: 0
      }
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
    }),
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores = this.$store.getters[
          "permissions/getPrestadoresByGeco"
        ]();
      },
    },
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
     ...mapActions('permissions', [
            "getOperadoras",
        ]),
    getHistorico(item) {
    let {processo_id, oper_nome, prest_nome, identificador_prestador} = item
    let obj = {
        query: [{ 
          Modulo: "Recebiveis",
          Acao: "gethistoricoeventoidentpagto",
          Payload: {
            grupo_economico: this.grupoEconomico,
            processo_id
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.historico.list  = response.dados
        this.historico.header = {oper_nome, prest_nome, identificador_prestador }
        this.dialog = true
      })
    },
    showOpen(item) {
      this.dialog = true
      let obj = {
        prestador_id: item.prestador_id,
        operadora_ans_id: item.operadora_ans_id,
        logins: item.logins,
        list: []
      }
      this.historico = obj
    },
    getList(filter, page) {
       this.filter = filter
       let limit = this.pagination.limit
       let offset = page? page : this.pagination.offset
       let obj = {
        query: [{ 
          Modulo: "Recebiveis",
          Acao: "getprocessosidentificacaopagamento",
          Payload: {...filter, limit, offset}
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.$store.commit('recebiveis/resetFilter', 'identPagamentosFilter', { root:true })
        this.list = response.dados
        this.hoje = filter.hoje? response.dt_inicio : null
        this.pagination.current_page = response.current_page
        this.pagination.offset = response.current_page
        this.pagination.total = response.total
        this.pagination.total_pages = response.total_pages
      })
    },
  }
}
</script>

<style>

</style>